export default {
  'Extract audio': 'Estrai audio',
  'Mute': 'Silenzia',
  'Split video and audio': 'Dividi video e audio',
}